export default "__VITE_ASSET__CPs9m0DU__"